<template>
  <div v-if="id !== undefined">
    <div v-if="surveysData" class="survey-info py-3 ps-4">
      <div
        class="col-9 d-flex justify-content-between align-items-center w-100"
      >
        <h5 class="card-title mb-0">
          {{ surveysData.dataset.surveyGroupName }} &nbsp; (
          {{ surveysData.dataset.total }} )
        </h5>
        <h5 class="card-description text-uppercase mb-0">
          {{ surveysData.dataset.year }}
          <span v-if="surveysData.dataset.quarter !== undefined">
            - R{{ surveysData.dataset.quarter.substring(1) }}</span
          >
        </h5>
      </div>
    </div>

    <div class="container py-5">
      <div v-if="surveysData" :class="'customerSegmentation' + id + index">
        <completed-survey-card
          :class-card="'customerSegmentation' + id + index"
          :dataset="surveysData.dataset"
          from="compare"
          :index="index"
          type="red"
        ></completed-survey-card>
      </div>

      <div class="container-section p-4">
        <h4 class="text-capitalize mb-5">Experience Scores</h4>
        <div>
          <experience-drivers-yes
            v-if="experienceDriversDataSet"
            :className="`experience-drivers-${id}`"
            :dataset="experienceDriversDataSet"
            :type="'experience'"
            :scallMin="-100"
            :scallMax="150"
          ></experience-drivers-yes>
        </div>
      </div>

      <template v-if="experienceDistributionDataset && surveysData">
        <bar-chart
          v-if="experienceDistributionDataset"
          :dataset="experienceDistributionDataset"
          :index="+id + 6"
          :scallMax="150"
          :scallMin="-100"
          :surveyId="id"
        />
      </template>

      <template
        v-if="
          totalSubmissionCount &&
          surveyLanguageBreakdown &&
          surveyLanguageBreakdown.length > 1
        "
      >
        <languages-breakdown
          :languages-data="surveyLanguageBreakdown"
          :totalLanguagesSubmissionsCount="totalSubmissionCount"
        ></languages-breakdown>
      </template>

      <div v-if="modesBreakdownDataset">
        <modes-breakdown
          :modes-breakdown-dataset="modesBreakdownDataset"
          :surveyId="id"
        ></modes-breakdown>
      </div>

      <div v-if="commentsCounts">
        <comments-breakdown
          :commentsCounts="commentsCounts"
          :survey-id="+id"
          surveyType="RED"
        ></comments-breakdown>
      </div>
    </div>
  </div>
</template>
<script>
import ModesBreakdown from "@/components/dashboard/surveys-charts/individual/modes-breakdown.vue";
import LanguagesBreakdown from "@/components/dashboard/surveys-charts/individual/languages-breakdown";
import CommentsBreakdown from "@/components/dashboard/surveys-charts/individual/comments-breakdown.vue";
import CompletedSurveyCard from "@/components/dashboard/surveys-cards/completed-survey-card.vue";

import { mapGetters } from "vuex";
import ExperienceDriversYes from "../surveys-charts/individual/yes-charts/experience-drivers-yes.vue";
import BarChart from "../surveys-charts/shared/bar-chart.vue";

export default {
  name: "SurveyForCompare",

  components: {
    ModesBreakdown,
    LanguagesBreakdown,
    CommentsBreakdown,
    CompletedSurveyCard,
    ExperienceDriversYes,
    BarChart,
  },

  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },

  computed: {
    ...mapGetters("mainStats", {
      getSurveyWithModesByIdCompareDataSet:
        "getSurveyWithModesByIdCompareDataSet",
      ModeBreakdownCompareData: "ModeBreakdownCompareData",
      surveysCommentsCountsData: "getCommentsCountsCompareData",
      languagesBreakdownCompareData: "getLanguagesBreakdownCompareData",
      experienceDriversCompareDataSet: "experienceDriversCompareDataSet",
      getOverallDistributionCompareData: "getOverallDistributionCompareData",
    }),

    surveysData() {
      return this.getSurveyWithModesByIdCompareDataSet.find(
        (element) => +element.dataset?.surveyId === +this.id
      );
    },

    modesBreakdownDataset() {
      return this.ModeBreakdownCompareData.find(
        (element) => +element?.surveyId === +this.id
      )?.dataset;
    },

    experienceDistributionDataset() {
      return this.getOverallDistributionCompareData?.find(
        (element) => +element?.surveyId === +this.id
      )?.dataset;
    },

    experienceDriversDataSet() {
      return this.experienceDriversCompareDataSet.find(
        (element) => +element?.surveyId === +this.id
      )?.dataset;
    },

    commentsCounts() {
      return this.surveysCommentsCountsData.find(
        (element) => +element.surveyId === +this.id
      )?.dataset;
    },

    surveyLanguageBreakdown() {
      return (
        this.languagesBreakdownCompareData.find(
          (element) => +element.surveyId === +this.id
        )?.dataset ?? []
      );
    },

    totalSubmissionCount() {
      let total = 0;
      for (let i in this.languagesBreakdown) {
        total += this.languagesBreakdown[i].langCount;
      }
      return total;
    },
  },

  async mounted() {
    try {
      setTimeout(() => {
        this.$store.dispatch("mainStats/loadSurveyWithModesById", {
          surveyId: this.id,
          multiSurvey: true,
          surveyType: "RED",
        });
      });

      setTimeout(() => {
        this.$store.dispatch("mainStats/fetchSurveyExperienceDrivers", {
          surveyId: this.id,
          multiSurvey: true,
        });
      }, 300);

      setTimeout(() => {
        this.$store.dispatch("mainStats/fetchExperienceDistributionRED", {
          surveyId: this.id,
          multiSurvey: true,
        });
      }, 600);

      setTimeout(() => {
        this.$store.dispatch("mainStats/fetchSurveyCommentsCount", {
          surveyId: this.id,
          multiSurvey: true,
        });
      }, 900);

      setTimeout(() => {
        this.$store.dispatch("mainStats/fetchSurveyQuestionAnswers", {
          surveyId: this.id,
          isDemographic: false,
          multiSurvey: true,
        });
      }, 1200);
      setTimeout(() => {
        this.$store.dispatch("mainStats/fetchSurveyLanguageBreakdown", {
          surveyId: this.id,
          multiSurvey: true,
        });
      }, 1800);
    } catch (error) {
      this.$store.dispatch("dialog/showErrorDialog", {
        error: error,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.card-title {
  text-align: left;
  font-weight: $font-weight-semiBold;
  color: $color-white;
  opacity: 1;
}

.card-description {
  text-align: left;
  color: $color-white;
  opacity: 1;
}

.survey-info {
  position: sticky;
  top: 0;
  background: $color-grey-100;
  z-index: 5;
  border-bottom: 1px solid $color-grey-60;
  p {
    color: $color-white;
  }

  .product-name {
    font-weight: $font-weight-semiBold;
  }
}
</style>
